var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission('staffAdminAccidentReports'))?_c('expansion-panel',{attrs:{"icon":"mdi-table","header":"Accident Reports"}},[_c('accident-report-table',{attrs:{"reports":_vm.reports,"page":_vm.$page.props.accidentReports.current_page},on:{"page-changed":_vm.pageChanged}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }